function PriceText(id){
    var subscriptionPrice = window.SubscriptionWidgetConfig ? window.SubscriptionWidgetConfig.formattedPrices[parseInt(id)]: "";
    if (subscriptionPrice != "") {
        document.querySelector(".option-box .price .old").textContent = subscriptionPrice.unit;
        document.querySelectorAll(".option-box .price .new")[1].textContent = subscriptionPrice.unit;
        document.querySelector(".option-box .price .new").textContent = subscriptionPrice.discounted;   
    }
    
    var option_price_per_day = "";
    var option_price_per_bottle = "";
    var option_gift_price = "";
    var option_delivery = "";
    var option_subscription_text = "";
    var option_onetime_text = "";
    var subscription_widget_badge_text = "";
    var discount_onetime= "";
    var price_onetime = "";
    var option_image = "";
    
    document.querySelectorAll(".gift-container").forEach(function(gift){
        var giftId = gift.getAttribute("data-id");
        gift.classList.add("hide");
        if (giftId == id) {
            gift.classList.remove("hide");
        }
    })

    var widget = document.querySelector("recharge-subscription-widget");
    if(widget && widget.shadowRoot && widget.shadowRoot.querySelector(".rc-purchase-option__input:checked") && widget.shadowRoot.querySelector(".rc-purchase-option__input:checked").value == 'onetime'){
        document.querySelectorAll(".gift-container").forEach(function(gift){
            gift.classList.add("hide");
        });

        document.querySelector(".oneTimeSubscriptionOption") ? document.querySelector(".oneTimeSubscriptionOption").classList.remove("hide"): "";
    }

    document.querySelectorAll(".variant-picker__option-values input:checked").forEach(function(input){
        option_price_per_day = input.nextElementSibling.querySelector(".option_price_per_day").textContent != "" ? "(" + input.nextElementSibling.querySelector(".option_price_per_day").textContent + ")": "";
        option_price_per_bottle = input.nextElementSibling.getAttribute("data-price-per-bottle");
        option_gift_price = input.nextElementSibling.getAttribute("data-gift-price");
        option_subscription_text = input.nextElementSibling.getAttribute("data-subscription");
        option_onetime_text = input.nextElementSibling.getAttribute("data-onetime");
        option_delivery = input.nextElementSibling.getAttribute("data-delivery");
        subscription_widget_badge_text = input.nextElementSibling.getAttribute("data-subscription-badge");
        discount_onetime = input.nextElementSibling.getAttribute("data-discount-onetime");;
        price_onetime = input.nextElementSibling.getAttribute("data-price-onetime");
        option_image = input.nextElementSibling.getAttribute("data-image");
        option_sub_image = input.nextElementSibling.getAttribute("data-sub-image");
    })

    if (option_image != "") {
        var checkSub = document.querySelector('[name="purchase-type"]:checked').value;
        document.querySelectorAll(".main-media-image img").forEach(function(img){
            if (checkSub == 'onetime') {
                img.setAttribute("src", option_image);
                img.setAttribute("srcset", option_image);
            }else{
                img.setAttribute("src", option_sub_image);
                img.setAttribute("srcset", option_sub_image);
            }
            
            setTimeout(() => {
                img.parentElement.click();    
            }, 10);
        })
    }
    
    var priceFormate = window.SubscriptionWidgetConfig.formattedPrices[parseInt(id)];
    var unit = priceFormate.unit;
    var discounted = priceFormate.discounted;
    var subscriptionPrice = document.querySelector("recharge-subscription-widget").shadowRoot.querySelector(".rc-purchase-option__subscription");

    var subscriptionHTML = "";

    if (option_subscription_text != "") {
        var option_subscription_texts = option_subscription_text.split("||")
        for (let i = 0; i < option_subscription_texts.length; i++) {
            const element = option_subscription_texts[i];
            subscriptionHTML = subscriptionHTML + "<li>"+ element +"</li>"
        }
    }

    window.oneTimeHTML = "";

    if (option_onetime_text != "") {
        var option_onetime_texts = option_onetime_text.split("||")
        for (let i = 0; i < option_onetime_texts.length; i++) {
            const element = option_onetime_texts[i];
            window.oneTimeHTML = window.oneTimeHTML + "<li>"+ element +"</li>"
        }
    }

    setTimeout(() => {    
        var ul = document.querySelector(".benefits");
        if (subscriptionHTML != "" && ul != "") {
            ul ? ul.innerHTML = subscriptionHTML: "";
        }

        var ul2 = document.querySelectorAll(".benefits")[1];
        if (window.oneTimeHTML != "" && ul2 != "") {
            ul2 ? ul2.innerHTML = window.oneTimeHTML: "";
        }

        var subscription_widget_badge = document.querySelector(".header-new .tag");
        subscription_widget_badge && subscription_widget_badge_text != "" ? subscription_widget_badge.textContent = subscription_widget_badge_text : "";
        
    }, 100);
}

document.querySelector("[name='id']").addEventListener("change", function(){
    var id = this.value;
    PriceText(id) 
});

var subscriptionWidget = setInterval(() => {
    var widget = document.querySelector("recharge-subscription-widget");
    if (widget) {
        
        var id = document.querySelector("[name='id']").value;
        var subscription = widget.shadowRoot.querySelector(".rc-purchase-option__subscription");
        var oneTime = widget.shadowRoot.querySelector(".rc-selection__onetime");
        widget.shadowRoot.querySelector("rc-selling-plans") ? widget.shadowRoot.querySelector("rc-selling-plans").style.display = 'none': "";
        subscription ? subscription.style.background = "#f5f5f5": "";

        subscription ? subscription.addEventListener("click", function(){
            var id = document.querySelector("[name='id']").value;
            
            document.querySelectorAll(".gift-container").forEach(function(gift){
                var giftId = gift.getAttribute("data-id");
                gift.classList.add("hide");
                if (giftId == id) {
                    gift.classList.remove("hide");
                }
            });

            setTimeout(() => {
                var widget2 = document.querySelector("recharge-subscription-widget");
                widget2.shadowRoot.querySelector("rc-selling-plans") ? widget2.shadowRoot.querySelector("rc-selling-plans").style.display = 'none': "";
                PriceText(id);
            }, 100);
        }): "";

        oneTime ? oneTime.addEventListener("click", function(){
            var widget3 = document.querySelector("recharge-subscription-widget");
            
            widget3.shadowRoot.querySelector("rc-selling-plans") ? widget3.shadowRoot.querySelector("rc-selling-plans").style.display = 'none': "";
            document.querySelectorAll(".gift-container").forEach(function(gift){
                gift.classList.add("hide");
            });

            document.querySelector(".oneTimeSubscriptionOption") ? document.querySelector(".oneTimeSubscriptionOption").classList.remove("hide"): "";
            var id = document.querySelector("[name='id']").value;
            PriceText(id);

            // setTimeout(() => {         
            //     var ul2 = widget3.shadowRoot.querySelector("rc-onetime-drawbacks") ? widget3.shadowRoot.querySelector("rc-onetime-drawbacks").shadowRoot.querySelector("ul"): "";
            //     if (window.oneTimeHTML != "" && ul2 != "") {
            //         ul2 ? ul2.innerHTML = window.oneTimeHTML: "";
            //     }
            // }, 1000);
        }): "";
        PriceText(id);

        document.querySelectorAll(".variant-picker__option-values input")[1].click();

        clearInterval(subscriptionWidget);
    }
}, 1000);

async function addToCart(items) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            items: items
        }),
      });

      if (!response.ok) {
        throw new Error('Error adding to cart');
      }

      const data = await response.json();

      window.SLIDECART_UPDATE()

      // Display a success message
     
      
      console.log('Add to Cart Response:', data); // Debug log
    } catch (error) {
      // Display error message
      
      
      console.error('Add to Cart Error:', error);
    }
  }


// document.querySelectorAll(".add_to_cart_div [type='submit']").forEach(function(button){
//     button.addEventListener("click", function(e){
//         e.preventDefault();
//         var gifts = this.closest(".product-info__block-list").querySelectorAll(".gift-container:not(.hide) .single-gift-container.selected_product");
//         var qty = this.closest(".product-info__block-list").querySelector("[name='quantity']") 
//                   ? parseInt(this.closest(".product-info__block-list").querySelector("[name='quantity']").value) 
//                   :1;
//         // var id = parseInt(this.closest(".product-info__block-list").querySelector("[name='id']").value);
//         var items = [];

//         // items.push({
//         //     id: id,
//         //     quantity: qty
//         // });

//         gifts.forEach(function(gift){
//             var id = parseInt(gift.getAttribute("data-id"));
//             items.push({
//                 id: id,
//                 quantity: qty
//             })
//         })

//         console.log(items);
//         setTimeout(() => {
//             addToCart(items);    
//         }, 1000);
        
//     })
// })